import React from 'react'
import PropTypes from 'prop-types'
import { NumericFormat } from 'react-number-format'
import { Chip, Avatar, Tooltip } from '@mui/material'
import { getInvoiceChipParams, getInvoiceGenerationStatusParams } from './utils'
import HHDisplayMoney from '../HHDisplayMoney'

const InvoiceStatusChip = ({
  status,
  isPartial = false,
  agingBucketType = '',
  count = 0,
  showAmount = false,
  amountCents = 0,
  generationStatus = '',
  generationFailure = '',
}) => {
  const { color, label } = getInvoiceChipParams(status, isPartial, agingBucketType)
  const { Icon, fullLabel, bgcolor } = getInvoiceGenerationStatusParams(generationStatus, generationFailure)

  return (
    <Chip
      size="small"
      avatar={
        <Tooltip arrow placement="bottom" title={fullLabel} disableHoverListener={!fullLabel}>
          <Avatar
            sx={{
              border: '1px solid',
              borderColor: color[500],
              backgroundColor: bgcolor,
              '&.MuiChip-avatar': {
                color: 'white',
              },
            }}
          >
            <Icon width={15} height={15} />
          </Avatar>
        </Tooltip>
      }
      variant="outlined"
      label={
        <>
          {count > 0 && <NumericFormat value={count} displayType="text" thousandSeparator />}
          {count > 0 && <>&nbsp;</>}
          {showAmount ? <HHDisplayMoney value={amountCents} /> : label}
        </>
      }
      sx={{
        fontWeight: 600,
        border: '1px solid',
        borderColor: color[500],
        backgroundColor: color[50],
        color: color[700],
      }}
    />
  )
}

InvoiceStatusChip.propTypes = {
  status: PropTypes.string,
  isPartial: PropTypes.bool,
  agingBucketType: PropTypes.string,
  count: PropTypes.number,
  showAmount: PropTypes.bool,
  amountCents: PropTypes.number,
  generationStatus: PropTypes.string,
  generationFailure: PropTypes.string,
}

export default InvoiceStatusChip
